export default __webpack_public_path__ + "static/media/p11.6289afa1.jpg";